import React, { useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import { UserGateway } from "../../gateways/UserGateway";
import { CountryCodes } from "../../model/UserModel";
import { Utils } from "../../common/Utils";
import { useNavigate } from "react-router-dom";

const Register: React.FC = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCode, setPhoneCode] = useState("+27");
  const [email, setEmail] = useState("");
  const [emailConfirm, setEmailConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<{ firstName?: string, lastName?: string, email?: string; confirmEmail?: string; password?: string; phoneNumber?: string; globalError?: string; }>({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();

    let newErrors: { firstName?: string, lastName?: string, email?: string; confirmEmail?: string; password?: string, phoneNumber?: string, globalError?: string } = {};

    if (firstName === "") {
      newErrors.firstName = "First Name is required";
    }
    if (lastName === "") {
      newErrors.lastName = "Last Name is required";
    }

    if (!phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
    }
    else if (!phoneNumber.match(/^\d{2,3}[\s]?\d{3}[\s]?\d{4}$/)) {
      newErrors.phoneNumber = "Invalid phone number format";
    }

    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      newErrors.email = "Invalid email format";
    }

    if (emailConfirm !== email) {
      newErrors.confirmEmail = "Emails do not match";
    }

    if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters long";
    }

    setErrors(newErrors)


    try {

      if (Object.keys(newErrors).length === 0) {
        setLoading(true);
        UserGateway.registerUser(email, password, firstName, lastName, phoneCode, phoneNumber);

        console.log(`User registered: ${firstName} ${lastName}`);

        navigate(Utils.GetUrl("/"));

        setFirstName("");
        setLastName("");
        setPhoneCode("");
        setPhoneNumber("");
        setEmail("");
        setEmailConfirm("");
        setPassword("");
      }
    } catch (err: any) {
      newErrors.globalError = "An error occurred during registration.";
      switch (err.code) {
        case "auth/email-already-in-use":
          newErrors.email = "The email address is already in use.";
          break;
        case "auth/invalid-email":
          newErrors.email = "The email address is not valid.";
          break;
        case "auth/weak-password":
          newErrors.email = "The password is too weak.";
          break;
      }
      console.error("Registration Error:", err);
    } finally {
      setErrors(newErrors);
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col xs={12} md={6}>
          <h2 className="text-center mb-4">Register</h2>
          {errors.globalError && <Alert variant="danger">{errors.globalError}</Alert>}
          <Form onSubmit={handleRegister}>
            <Form.Group className="mb-3">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="text"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                isInvalid={!!errors.firstName}
              />
              <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="text"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                isInvalid={!!errors.lastName}
              />
              <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">

              <Form.Label>Cellphone Number</Form.Label>
              <Row className="gx-2">
                <Col xs={12} md={4}>


                  <Form.Select
                    value={phoneCode}
                    onChange={(e) => setPhoneCode(e.target.value)}
                  >
                    {CountryCodes.map((country, index) => (
                      <option key={index} value={country.code}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </Form.Select>
                </Col><Col xs={12} md={8}>
                  <Form.Control
                    type="text"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    isInvalid={!!errors.phoneNumber}
                  />
                  <Form.Control.Feedback type="invalid">{errors.phoneNumber}</Form.Control.Feedback>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Confirm Email</Form.Label>
              <Form.Control
                type="email"
                value={emailConfirm}
                onChange={(e) => setEmailConfirm(e.target.value)}
                isInvalid={!!errors.confirmEmail}
              />
              <Form.Control.Feedback type="invalid">{errors.confirmEmail}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">{errors.password}</Form.Control.Feedback>
            </Form.Group>

            <Button type="submit" variant="primary" disabled={loading} className="w-100">
              {loading ? "Registering..." : "Register"}
            </Button>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default Register;